import { render, staticRenderFns } from "./CommentItemBasic.vue?vue&type=template&id=477b7e40&scoped=true&"
import script from "./CommentItemBasic.vue?vue&type=script&lang=ts&"
export * from "./CommentItemBasic.vue?vue&type=script&lang=ts&"
import style0 from "./CommentItemBasic.vue?vue&type=style&index=0&id=477b7e40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b7e40",
  null
  
)

export default component.exports